import { IArticlesProps } from './interfaces';
import React from 'react';

import { ArticleSummary } from './ArticleSummary';
import { useRouter } from 'next/router';
import Pagination from 'components/core/Pagination/Pagination';
import { ParsedUrlQueryInput } from 'node:querystring';
import { ArticlesListSection } from './styles';

export const numberOfItemsOnPage = 10;
export const Articles = ({
  articles,
  articlesCount,
  currentPage,
  contentPage,
}: IArticlesProps): JSX.Element => {
  const {
    query: { tag, number },
    ...router
  } = useRouter();

  const onPageChangeHandler = (pageIndex: number) => {
    const routerQuery: ParsedUrlQueryInput = {
      page: pageIndex,
    };
    if (tag) {
      routerQuery.tag = tag;
    }

    const tagPath = tag ? `tag/${tag}/` : '';
    const pagePath = pageIndex ? `page/${pageIndex}/` : '';

    router.push({
      pathname:
        pageIndex !== 1
          ? `/insights/${tagPath}${pagePath}`
          : `/insights/${tagPath}`,
    });
  };
  return (
    <ArticlesListSection>
      <div>
        {articles.map((article, index): JSX.Element => {
          return (
            <ArticleSummary
              key={index}
              article={article}
              contentPage={contentPage}
            />
          );
        })}
      </div>
      {articlesCount > numberOfItemsOnPage && (
        <Pagination
          totalCount={articlesCount}
          pageSize={numberOfItemsOnPage}
          activePage={currentPage}
          relatedParams={tag}
          onPageChange={onPageChangeHandler}
        />
      )}
    </ArticlesListSection>
  );
};
